module.exports = __webpack_public_path__ + "img/WorkOrder.62bddec5.svg";